import { useEffect, useRef, useState } from 'react';

export default function LiveCaptions({ enabled }: { enabled: boolean }) {
    const [text, setText] = useState('');
    const recRef = useRef<any>(null);

    useEffect(() => {
        const SR = (window as any).SpeechRecognition || (window as any).webkitSpeechRecognition;
        if (!SR || !enabled) {
            recRef.current?.stop();
            recRef.current = null;
            setText('');
            return;
        }

        const r = new SR();
        r.continuous = true;
        r.interimResults = true;
        r.lang = 'en-US';

        r.onresult = (e: any) => {
            let out = '';
            for (let i = 0; i < e.results.length; i++) {
                out += e.results[i][0].transcript + (e.results[i].isFinal ? ' ' : '');
            }
            setText(out.trim());
        };

        r.onerror = () => {};
        r.onend = () => { if (recRef.current) r.start(); };

        recRef.current = r;
        r.start();

        return () => {
            r.stop();
            recRef.current = null;
            setText('');
        };
    }, [enabled]);

    if (!enabled || !text) return null;

    return (
        <div className="lc-wrap">
            <p className="lc-text">{text}</p>
            <style>{`
                .lc-wrap {
                    position: absolute;
                    bottom: 18px;
                    left: 50%;
                    transform: translateX(-50%);
                    z-index: 30;
                    max-width: min(72%, 720px);
                    width: max-content;
                    text-align: center;
                    pointer-events: none;
                }
                .lc-text {
                    display: inline-block;
                    background: rgba(8, 10, 16, 0.82);
                    backdrop-filter: blur(10px);
                    -webkit-backdrop-filter: blur(10px);
                    color: #f8fafc;
                    font-size: 1rem;
                    font-weight: 500;
                    padding: 0.55rem 1.25rem;
                    border-radius: 12px;
                    line-height: 1.55;
                    margin: 0;
                    letter-spacing: 0.01em;
                    border: 1px solid rgba(255,255,255,0.1);
                    box-shadow: 0 8px 24px rgba(0,0,0,0.35);
                }

                @media (max-width: 768px) {
                    .lc-wrap {
                        bottom: 12px;
                        max-width: calc(100% - 1rem);
                        padding: 0 0.5rem;
                    }
                    .lc-text {
                        font-size: 0.88rem;
                        padding: 0.45rem 0.9rem;
                        border-radius: 10px;
                    }
                }
            `}</style>
        </div>
    );
}
